import { render, staticRenderFns } from "./ViewContactPage.vue?vue&type=template&id=8ef66f48"
import script from "./ViewContactPage.vue?vue&type=script&lang=js"
export * from "./ViewContactPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports